export default {
  productName: 'Boxing Gloves',
  pathId: 'fightcamp-gloves',
  description: 'Made from premium genuine leather for lasting durability and wrist support. Hand-crafted with extra padding for impact protection and added weight to build strength. Built for serious training — better than vinyl and made to last.',
  shortDescription: 'Boxing Gloves',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/800x800/19ebd210cc/gloves.jpg',
    alt: 'White FightCamp boxing gloves',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/400x362/d48f334ba2/fc-boxing-gloves-lifestyle-001.png',
    alt: 'FightCamp boxing gloves',
  },
  includesModalCopy: {},
  assets: [],
  features: [
    {
      title: 'Features',
      copy: [
        'Ventilated palms for breathability',
        'Hook and loop wrist enclosure',
        'Multi-layered foam padding',
        'FightCamp logo on cuff',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Available in 12oz, 16oz (oz refers to weight of padding in the glove)',
        'Less than 5’9” / 170lb+ typically use 12oz (also great for speed of combinations)',
        'Above 5’9” / 170lb typically use 16oz (builds shoulder strength over time)',
        'Ergonic fit',
        'Also available in Kids Size typically for Age 12 and under',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        'Made from premium leather',
        'Wipe clean with damp cloth; do not machine wash',
      ],
    },
  ],
};
